/* F47: pre-wiring can only be checked out with a Factory 47 handlebar in the same cart. */
(function () {
  var PREWIRE_IDS = [14668237439343, 14917860327791];
  var MSG = 'Pre-wiring has to be ordered with a Factory 47 handlebar. Add a handlebar to your cart to check out.';
  var HIDE_SEL = '[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"], .shopify-payment-button, #dynamic-checkout-cart, .dynamic-cart-btns, shopify-accelerated-checkout-cart, [data-sticky-express], redo-shopify-toggle';
  var blocked = false;
  var busy = false;

  function isF47Bar(item) {
    return /handlebar/i.test(item.product_type || '') && /factory\s*47/i.test(item.vendor || '');
  }

  function apply() {
    busy = true;
    document.querySelectorAll(HIDE_SEL).forEach(function (el) {
      if (blocked) {
        if (!el.dataset.f47Hidden) { el.dataset.f47Hidden = '1'; el.dataset.f47Style = el.getAttribute('style') || ''; el.style.cssText += ';display:none!important;position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;clip-path:inset(50%)!important;opacity:0!important;pointer-events:none!important;'; }
      } else if (el.dataset.f47Hidden) {
        if (el.dataset.f47Style) { el.setAttribute('style', el.dataset.f47Style); } else { el.removeAttribute('style'); } delete el.dataset.f47Hidden; delete el.dataset.f47Style;
      }
    });
    document.querySelectorAll('.f47-prewire-guard').forEach(function (n) { if (!blocked) n.remove(); });
    if (blocked) {
      document.querySelectorAll('[name="checkout"]').forEach(function (btn) {
        var prev = btn.previousElementSibling;
        if (prev && prev.classList.contains('f47-prewire-guard')) return;
        var note = document.createElement('p');
        note.className = 'f47-prewire-guard';
        note.setAttribute('role', 'alert');
        note.textContent = MSG;
        note.style.cssText = 'margin:0 0 12px;padding:12px;border-radius:4px;background:#fff4e5;color:#6b3b00;font-size:14px;line-height:1.4;';
        btn.parentNode.insertBefore(note, btn);
      });
    }
    setTimeout(function () { busy = false; }, 0);
  }

  function check() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var hasPrewire = items.some(function (i) { return PREWIRE_IDS.indexOf(i.product_id) !== -1; });
        blocked = hasPrewire && !items.some(isF47Bar);
        apply();
      })
      .catch(function () {});
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input) {
    var p = nativeFetch.apply(this, arguments);
    try {
      var url = String((input && input.url) || input);
      if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { setTimeout(check, 400); });
    } catch (e) {}
    return p;
  };

  document.addEventListener('submit', function (e) {
    if (!blocked) return;
    var s = e.submitter;
    if (s && s.name === 'checkout') { e.preventDefault(); apply(); }
  }, true);

  document.addEventListener('click', function (e) {
    if (!blocked) return;
    var a = e.target.closest && e.target.closest('a[href*="/checkout"], [name="checkout"], redo-shopify-toggle');
    if (a) { e.preventDefault(); e.stopPropagation(); apply(); }
  }, true);

  var timer;
  new MutationObserver(function () {
    if (busy || !blocked) return;
    clearTimeout(timer); timer = setTimeout(apply, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (/\/products\/pre-wire-handlebar-add-on/.test(location.pathname)) {
    var st = document.createElement('style');
    st.textContent = '.shopify-payment-button, [data-sticky-express] { display: none !important; }';
    document.head.appendChild(st);
  }

  check();
})();
